module.exports = __webpack_public_path__ + "static/media/Gleam-Giveaway-Play-Learn.a45e3ceb.png";